module.exports = __webpack_public_path__ + "static/img/ecu.bca54af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ecu.svg
// module id = E/j8
// module chunks = 0